import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './MarkedText.css';

interface MarkedTextProps {
    text: string;
    search: string;
}

const blockClass = 'marked-text';

export function MarkedText({ text, search }: MarkedTextProps): JSX.Element {
    const start = text.toLowerCase().indexOf(search.toLowerCase());
    const isMatched = search.length && start !== -1;

    if (!isMatched) {
        return <span>{text}</span>;
    }

    return (
        <span>
            {text.substr(0, start)}
            <span className={Bem.cls(blockClass, 'mark')}>{text.substr(start, search.length)}</span>
            {text.substr(start + search.length)}
        </span>
    );
}
